import { memo } from "react";

import classnames from "classnames";
import { Neeto } from "neetoicons/typeface-logos";
import * as AppIcons from "neetoicons/typeface-logos";

import { SPECIAL_APP_NAMES } from "./constants";

const ProductLink = ({
  name,
  description,
  url,
  isHighlighted = false,
  ...props
}) => {
  const normalizedName = (name || "").toLowerCase();
  const specialCase = SPECIAL_APP_NAMES[normalizedName];

  const safeName = name || "";
  const appName = `Neeto${safeName.charAt(0)}${safeName.slice(1).toLowerCase()}`;

  const AppIcon = specialCase
    ? AppIcons[`Neeto${specialCase}`]
    : AppIcons[appName];

  return (
    <a
      data-testid={`${normalizedName}-app-link`}
      href={url}
      rel="noreferrer"
      target="_blank"
      className={classnames(
        "bg-background focus-visible:bg-accent flex w-full max-w-full cursor-pointer flex-col gap-4 rounded-lg border p-2.5 no-underline transition-all outline-none",
        {
          "border-primary bg-primary/5": globalProps?.appName?.includes(name),
          "nv-product-link-highlighted bg-accent": isHighlighted,
          "border-border hover:border-primary":
            !globalProps?.appName?.includes(name),
        }
      )}
      {...props}
    >
      <div className="shrink-0 grow [&>svg]:h-9 [&>svg]:w-auto">
        {AppIcon ? <AppIcon /> : <Neeto className="h-6 w-auto" />}
      </div>
      <div className="shrink-0">
        <span className="text-muted-foreground block text-xs">
          {description}
        </span>
      </div>
    </a>
  );
};

export default memo(ProductLink);
